import '../App.less';
import RunRegister from './RunRegister';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { FC, useEffect, useState } from 'react';
import { IMenu } from './../model/IMenu';

/* Instancia del cliente de graphql */
const client = new ApolloClient({
    uri: `${process.env.REACT_APP_SERVICES_DOMAIN}/graphql`,
    /*     headers:{
            Authorization:`Basic ${process.env.REACT_APP_APOLLO_BASIC_AUTH}` 
        }, */
    cache: new InMemoryCache({
        addTypename: false
    }),

});

const Run: FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [menu, setMenu] = useState<IMenu>()


    useEffect(() => {
        if(isLoading){
            fetch(`${process.env.REACT_APP_URL_BLOB}/config/data/menucontenido.json`)
            .then((response) => response.json())
            .then((menu) => {
              setMenu(menu); 
              setIsLoading(false); 
            });
        }
      
           
      }, [isLoading , menu]);

    return (
        !isLoading ?
        <ApolloProvider client={client}>
            <RunRegister menu={menu as IMenu} client={client}/>
        </ApolloProvider>
        : <></>
        
    )
}
export default Run;